enum ProjectItemType {
	Folder = 0,
	File = 1,
	Project = 2,
	Solution = 3
}

export { ProjectItemType };
